export function bmElementFormRules(ruleNames) {
	var rules = {
		// 所有的验证规则再此列出
		required: [
			// 必填(所有)
			{ required: true, message: '不能为空', trigger: 'blur' }
		],
		date: [
			// 时间格式
			{ required: true, validator: dateValidator, message: '', trigger: 'blur' }
		],
		select: [
			// select类型验证
			{ validator: selectValidator, message: '', trigger: 'blur' }
		],
		email: [
			// 邮箱
			{ required: true, message: '请输入正确的邮箱地址', trigger: 'blur', type: 'email' }
		],
		idCard: [
			// 身份证
			{ required: true, validator: idCardValidator, message: '', trigger: 'blur' }
		],
		phone: [
			// 电话-座机 格式0551-65604243
			{ required: true, validator: phoneValidator, message: '', trigger: 'blur' }
		],
		mobilePhone: [
			// 电话-手机
			{ required: true, validator: mobilePhoneValidator, message: '', trigger: 'blur' }
		],
		allPhone: [
			// 座机和手机
			{ required: true, validator: phoneAndMobile, message: '', trigger: 'blur' }
		],
		number: [
			// 数字
			{ required: true, validator: numberPhoneValidator, message: '', trigger: ['blur', 'change'] }
		],
		amount: [
			// 金额
			{ required: true, validator: amountValidator, message: '', trigger: ['blur'] }
		],
		chinese: [
			// 中文
			{ required: true, validator: chineseValidator, message: '', trigger: ['blur', 'change'] }
		],
		english: [
			// 英文
			{ required: true, validator: englishValidator, message: '', trigger: ['blur', 'change'] }
		],
		url: [
			// url
			{ required: true, validator: urlValidator, message: '', trigger: 'blur' }
		],
		isUrl: [
			// 验证是否是以http://， https://，或者ftp://开头的正确网址！
			{ required: true, validator: isUrlAddress, message: '', trigger: 'blur' }
		],
		upper: [
			// 大写
			{ required: true, validator: upperValidator, message: '', trigger: ['blur', 'change'] }
		],
		lower: [
			// 小写
			{ required: true, validator: lowerValidator, message: '', trigger: ['blur', 'change'] }
		],
		pwd: [
			// 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
			{ required: true, validator: pwdValidator, message: '', trigger: 'blur' }
		],
		postal: [
			// 邮政编码
			{ required: true, validator: postalValidator, message: '', trigger: 'blur' }
		],
		minMax: [
			// 数字区间
			{ required: true, validator: minMaxValidator, message: '', trigger: 'blur', min: 0, max: 0 }
		],
		length: [
			// 字符长度
			{ required: true, validator: lengthValidator, message: '', trigger: 'blur', length: 0 }
		],
		numberF: [
			// 正整数字 但非必填
			{ required: false, validator: numberintValidator, message: '', trigger: ['blur', 'change'] }
		],
		numberT: [
			// 正整数字 必填
			{ required: true, validator: numberintValidator, message: '', trigger: ['blur', 'change'] }
		],
		numberLess999: [
			// 报价轮次小于1000
			{ required: false, validator: less1000Validator, message: '', trigger: ['blur', 'change'] }
		],
		numberLess99: [
			// 整数且小于99
			{ required: true, validator: less99Validator, message: '', trigger: 'blur' }
		],
		requiredchange: [
			// 下拉必填(所有)
			{ required: true, message: '不能为空', trigger: 'change' }
		],
		requiredchangeNum: [
			// 下拉必填(所有)
			{ required: true, type: 'number', message: '不能为空', trigger: 'change' }
		],
		requiredchangeArr: [
			// 下拉必填(所有)
			{ required: true, type: 'array', message: '不能为空', trigger: 'change' }
		],
		Integerwithuptotwodecimal: [
			// 整数且最多保留小数点后两位
			{ required: true, message: '格式错误，需整数且最多保留小数点后两位', trigger: ['blur', 'change'] }
		],
		isIntegertoDecimal: [
			// 整数最多保留18位，小数位保留两位
			{ required: true, validator: isIntegertoDecimal, message: '', trigger: 'blur' }
		],
		isCode: [
			// 公司组织机构代码
			{ required: true, validator: isCode, message: '', trigger: 'blur' }
		],
		isEmptyAll: [
			// 输入内容不能全部是空格
			{ required: true, validator: isEmptyAll, message: '', trigger: 'blur' }
		]
	}

	let reRule = {}

	ruleNames.map(function(i) {
		Object.keys(rules).map(function(x) {
			if (x === i.validatorName) {
				var obj = {
					required: rules[x][0].required,
					trigger: rules[x][0].trigger
				}
				if (!bmDataCheck(rules[x][0].message, 'undefined')) {
					if (rules[x][0].message.length > 0) {
						obj.message = (i.tip || '') + rules[x][0].message
					}
				}
				if (!bmDataCheck(rules[x][0].validator, 'undefined')) {
					obj.validator = rules[x][0].validator
				}
				if (!bmDataCheck(rules[x][0].type, 'undefined')) {
					obj.type = rules[x][0].type
				}
				if (!bmDataCheck(rules[x][0].min, 'undefined')) {
					obj.min = i.min
				}
				if (!bmDataCheck(rules[x][0].max, 'undefined')) {
					obj.max = i.max
				}
				if (!bmDataCheck(rules[x][0].length, 'undefined')) {
					obj.max = i.length
				}
				obj.tip = i.tip
				reRule[i.keyName] = [obj]
			}
		})
	})
	// console.log(reRule)
	return reRule
}

// date
function dateValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else {
		callback()
	}
}

// select
function selectValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value.name)) {
		callback(new Error(rule.tip + '不能为空'))
	} else {
		callback()
	}
}

// idCard
function idCardValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isIdCard(value)) {
		callback('请输入正确的身份证号')
	} else {
		callback()
	}
}

// phone座机
function phoneValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isPhone(value)) {
		callback('请输入正确的座机号码, 格式如: 021-54326693')
	} else {
		callback()
	}
}

// phone手机
function mobilePhoneValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isMobileReg(value)) {
		callback(new Error('请输入正确的手机号码'))
	} else {
		callback()
	}
}
//phoneAndMobile 座机 和手机
function phoneAndMobile(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isphoneAndMobile(value)) {
		callback(new Error('请输入正确号码！'))
	} else {
		callback()
	}
}

// 数字
function numberPhoneValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isNumber(parseFloat(value))) {
		callback(new Error('请输入数字'))
	} else {
		callback()
	}
}

// 数字 正整数
function numberintValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isNumberInt(value)) {
		callback(new Error(rule.tip + '请输入整数'))
	} else {
		callback()
	}
}
// 金额
function amountValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (isNaN(Math.floor(value * 100) / 100)) {
		callback(new Error('请输入合法金额'))
	} else if (!bmDataCheckjs.isLegalAmount(parseFloat(value))) {
		callback(new Error('请输入合法金额'))
	} else {
		callback()
	}
}

// 中文
function chineseValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'chinese')) {
		callback(new Error('请输入中文'))
	} else {
		callback()
	}
}

// 英文
function englishValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'english')) {
		callback(new Error('请输入英文'))
	} else {
		callback()
	}
}

// url
function urlValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isURL(value)) {
		callback(new Error('请输入正确的url'))
	} else {
		callback()
	}
}

//验证网址是否http，https,ftp开头
function isUrlAddress(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isUrlAddress(value)) {
		callback(new Error(rule.tip + '请输入以http://或https://或ftp://开头的正确网址！'))
	} else {
		callback()
	}
}

// 大写
function upperValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'upper')) {
		callback(new Error('请输入大写'))
	} else {
		callback()
	}
}

// 小写
function lowerValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'lower')) {
		callback(new Error('请输入小写'))
	} else {
		callback()
	}
}

// 密码
function pwdValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'pwd')) {
		callback(new Error('请输入正确的密码, 以字母开头，长度在6~18之间，只能包含字母、数字和下划线'))
	} else {
		callback()
	}
}

// 邮政编码
function postalValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.checkStr(value, 'postal')) {
		callback(new Error('请输入正确的邮政编码'))
	} else {
		callback()
	}
}

// 数字区间
function minMaxValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.maxMinLength(value, rule.min, rule.max)) {
		callback(new Error('数字区间输入不合法'))
	} else {
		callback()
	}
}

// 字符长度
function lengthValidator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.lengthCheck(value, rule.length)) {
		callback(new Error('字符长度不合法'))
	} else {
		callback()
	}
}

// 报价轮次小于1000
function less1000Validator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isNumberLess1000(value)) {
		callback(new Error(rule.tip + '请输入小于1000的正整数'))
	} else {
		callback()
	}
}

// 整数且小于99
function less99Validator(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isNumberLess99(value)) {
		callback(new Error(rule.tip + '请输入1-99的正整数'))
	} else {
		callback()
	}
}

// 整数且最多保留小数点后两位
function IntegerWithUpToTwoDecimal(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.IntegerWithUpToTwoDecimal(value)) {
		callback(new Error(rule.tip + '请输入整数且最多保留小数点后两位'))
	} else {
		callback()
	}
}

// 整数最多保留18位，小数位保留两位
function isIntegertoDecimal(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isIntegertoDecimal18(value)) {
		callback(new Error(rule.tip + '格式错误，整数最多保留18位，小数位保留两位'))
	} else {
		callback()
	}
}

// 组织机构代码验证
function isCode(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isCoderight(value)) {
		callback(new Error(rule.tip + '格式错误！'))
	} else {
		callback()
	}
}
// 组织机构代码验证
function isEmptyAll(rule, value, callback) {
	if (!bmDataCheckjs.isEmpty(value)) {
		callback(new Error(rule.tip + '不能为空'))
	} else if (!bmDataCheckjs.isEmptyAllright(value)) {
		callback(new Error(rule.tip + '格式错误！'))
	} else {
		callback()
	}
}



//////////////////
// WEBPACK FOOTER
// ./static/commonplugin/elementFormRules.js
// module id = v6mE
// module chunks = 13